export const GET_NAME_FROM_LANE_AND_EQIUPMENT = ({
	originCity,
	originState,
	destCity,
	destState,
	equipmentType,
}: Input) => {
	const equipment = equipmentType
		?.split(',')
		.map((equip) => equip[0])
		.join(',');
	return `${originCity}, ${originState} → ${destCity}, ${destState} (${equipment})`;
};

interface Input {
	originCity: string;
	originState: string;
	destCity: string;
	destState: string;
	equipmentType: string;
}
